'use client';

import {OutlinedTextField as GFiberTextField} from '@pixel-party/OutlinedTextField/v2';
import type {ComponentProps, ReactNode} from 'react';
import {forwardRef} from 'react';

type BaseProps = ComponentProps<typeof GFiberTextField>;

interface Props extends Omit<BaseProps, 'errorText'> {
  label: string;
  errorText?: ReactNode;
}

export const TextField = forwardRef<HTMLInputElement, Props>(
  ({label, errorText, required, ...props}, ref) => {
    return (
      <GFiberTextField
        {...props}
        ref={ref}
        id={props.id || props.name}
        invalid={!!errorText}
        errorText={errorText}
        required={required}
        label={label ? `${label}${required ? ' *' : ''}` : undefined}
      />
    );
  },
);

TextField.displayName = 'TextField';
